import * as z from 'zod';

export const CounterFormSchema = z.object({
  counterName: z.string().trim().min(1, 'Counter name is required'),
  branchId: z.coerce.number().int().min(1, 'Branch is required'),
  isActive: z.boolean(),
});

export type CounterSchemaT = z.infer<typeof CounterFormSchema>;